import { Product } from '@eo-storefronts/eo-core'
import { Box } from '@mui/material'
import { useEffect, useMemo } from 'react'
import Card from '~/src/components/mui-wrappers/Card'
import ProductAvailabilityAlerts from '~/src/components/products/ProductAvailabilityAlerts'
import ProductMaxQuantityAlert from '~/src/components/products/ProductMaxQuantityAlert'
import ProductConfigurationCloseButton, {
  ProductConfigurationCloseButtonProps
} from '~/src/components/products/modals/configuration/ProductConfigurationCloseButton'
import ProductDetailsFooter from '~/src/components/products/product-details/product-details-footer'
import ProductDetailsImg from '~/src/components/products/product-details/product-details-img'
import ProductDetailsInfoContainer from '~/src/components/products/product-details/product-details-info-container'
import useProductDetailsTemplateService
  from '~/src/components/products/product-details/styles/useProductDetailsTemplateService'
import useLogViewItem from '~/src/hooks/analytics/ecommerce/useLogViewItem'
import {
  productHasAllergens,
  productHasDescription,
  productHasImage,
  productHasModifiers
} from '~/src/services/ProductService'
import ProductDetailsTitle from './product-details-title'
import { useEoValue } from '~/src/hooks/useEoState'
import { LANGUAGE_STATE } from '~/src/stores/lang'
import {
  ProductDetailsArgs
} from '~/src/components/products/product-details/styles/ProductDetailsTemplateServiceInterface'

interface Props extends ProductConfigurationCloseButtonProps {
  product: Product,
}

const ProductDetails = ({ product, pullerShown }: Props) => {
  const { log: logViewItem } = useLogViewItem()
  const lang = useEoValue(LANGUAGE_STATE)
  const styles = useProductDetailsTemplateService()

  const productDetailsArgs: ProductDetailsArgs = useMemo((): ProductDetailsArgs => {
    return {
      hasImage: productHasImage(product),
      hasAllergens: productHasAllergens(product),
      hasDescription: productHasDescription(product, lang),
      hasModifiers: productHasModifiers(product)
    }
  }, [ product, lang ])

  useEffect(() => {
    logViewItem(product)
  }, [])

  return (
    <Card
      id='product_details'
      sx={{ p: 0 }}
      elevation={styles.getCardElevation()}>
      <ProductConfigurationCloseButton pullerShown={pullerShown}/>
      <ProductAvailabilityAlerts product={product}/>
      <ProductMaxQuantityAlert product={product}/>
      <Box sx={styles.getContainerSx(productDetailsArgs)}>
        <ProductDetailsImg product={product}/>
        <Box sx={styles.getTitleSx()}>
          <ProductDetailsTitle product={product}/>
        </Box>
        { (productDetailsArgs.hasAllergens || productDetailsArgs.hasDescription || productDetailsArgs.hasModifiers) && (
          <Box sx={styles.getInfoSx(productDetailsArgs.hasImage)}>
            <ProductDetailsInfoContainer product={product}/>
          </Box>
        )}
        <Box sx={styles.getFooterSx(productDetailsArgs.hasImage)}>
          <ProductDetailsFooter product={product}/>
        </Box>
      </Box>
    </Card>
  )
}

export default ProductDetails
